module.exports = __webpack_public_path__ + "img/drawing_secai.c278b848.png";